import React from 'react';
import { Box } from '@mui/material';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import AppHeader from './AppHeader';
import { useSelector } from 'react-redux';
import Grid from '../components/challenge/Grid';
import Code from '../components/challenge/Code';
import Cube from './challenge/Cube';
import JoystickChallenge from './challenge/JoystickChallenge';

export default function Challenge() {
  const theme = useTheme();

  const isGridState = useSelector((state) => state.challenge.isGrid);

  return (
    <React.Fragment>

      <AppHeader />

      {isGridState ?
        <Box>
          <Code location='grid' />
          <Grid />
        </Box>
        :
        // <Box sx={{
        //   padding: '40px',
        // }}
        // >
        //    <Cube /> 
        <Box>
          <Box
            sx={{
              // borderBottom: '2px solid #3B4E68',
              // paddingTop: '10px',
              // paddingBottom: '10px',
              // paddingTop: '5px',
              paddingBottom: '8px',
            }}
          >
            <Typography
              // variant='body1'
              variant='h5'
              sx={{
                // fontSize: '0.8em',
                color: '#3B4E68',
                fontWeight: 'bold',
              }}
            >
              Sign in
              {/* Swipe to align selector with your pattern */}
            </Typography>
          </Box>
          {/* <Code location='joystick' /> */}
          <JoystickChallenge />
        </Box>
      }

    </React.Fragment>

  );
}